export const unitTypes = {
  types: [
    { value: 'Suite' },
    { value: 'Unit' },
    { value: 'Room' },
    { value: 'Apt' },
    { value: 'Building'}
  ],
};
